<div class="mb-3">
  <mwp-translation />
</div>
@if (loginForm) {
  <form [formGroup]="loginForm" autocomplete="off">
    <div class="mb-3">
      <mwp-input [form]="loginForm" labelName="User Name" nameForControl="username" />
    </div>
    <div class="mb-3">
      <mwp-input [form]="loginForm" labelName="Password" nameForControl="currentPassword" inputType="password" />
    </div>
    <div>
      <mwp-agent-location [form]="loginForm" nameForRadioControl="agentLocation" />
    </div>
    <div>
      @if (useSecondaryCaptcha) {
        <mwp-captcha-google [form]="loginForm" [nameForRadioControl]="reCaptchaToken" [nameForRadioControlId]="reCaptchaTokenId" (emitReloadCaptcha)="reloadCaptcha($event)"/>
      } @else {
        <mwp-captcha-cloudflare [form]="loginForm" [nameForRadioControl]="reCaptchaToken" [nameForRadioControlId]="reCaptchaTokenId" (emitReloadCaptcha)="reloadCaptcha($event)"/>
      }
    </div>
  </form>
}
<div class="w-100">
  <button class="mwp-button w-100" [disabled]="!loginForm.valid" (click)="submitLogIn()">
    <mwp-text-translate text="Sign In" jsonKey="signIn" />
  </button>
</div>